import { render, staticRenderFns } from "./Rating1Star.vue?vue&type=template&id=2e41eae6"
import script from "./Rating1Star.vue?vue&type=script&lang=js"
export * from "./Rating1Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e41eae6')) {
      api.createRecord('2e41eae6', component.options)
    } else {
      api.reload('2e41eae6', component.options)
    }
    module.hot.accept("./Rating1Star.vue?vue&type=template&id=2e41eae6", function () {
      api.rerender('2e41eae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Rating1Star.vue"
export default component.exports